import { ISuKienSelectRequest } from "../../../model/request/tkb/ISuKienSelectRequest";
import { ISuKienUpdateRequest } from "../../../model/request/tkb/ISuKienUpdateRequest";
import { IMonHoc } from "../../../model/respone/category/IMonHoc";
import { IStuNhomLopViewModel } from "../../../model/respone/category/IStuNhomLopViewModel";
import { IStuNhomLopCaHocGiaiDoan } from "../../../model/respone/category/IStuNhomLopCaHocGiaiDoan";
import { IKeHoachMonViewModel } from "../../../model/respone/ke-hoach/IKeHoachMonViewModel";
import { ISuKienViewModel } from "../../../model/respone/lop-tin-chi/ISuKienViewModel";
import { eReducerStatusBase } from "../eReducerStatusBase";
export enum eXepTKBStatus {
    is_loading_kh = "is_loading_kh",
    is_completed_kh = "is_completed_kh",
}
export interface IXepTKBReducer {
    status: eReducerStatusBase | eXepTKBStatus,
    filter: ISuKienSelectRequest,
    suKiens: ISuKienViewModel[],
    keHoachMons: IKeHoachMonViewModel[],
    nhomLopId: number,
    nhomLopGhepCapId: number,
    keHoachMonSelected?: IKeHoachMonViewModel,
    monHocs: IMonHoc[],
    monHocIdsChuaHoanThanh: number[],
    nhomLops: IStuNhomLopViewModel[],
    /** Mapping ca học theo giai đoạn của các nhóm lớp trong đợt (board ưu tiên ca này hơn ca_hoc mặc định). */
    nhomLopCaHocGiaiDoans: IStuNhomLopCaHocGiaiDoan[],
    modeDisplay: "all" | "chua-xep",
    /** Trùng (phòng/GV) server trả về, chờ người dùng xác nhận ghi đè. undefined = không có. */
    trungConflict?: { request: ISuKienUpdateRequest; message: string }
}
